import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-layout" }
const _hoisted_2 = {
  key: 1,
  class: "footer-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageLoader = _resolveComponent("PageLoader")!
  const _component_SiteNav = _resolveComponent("SiteNav")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_SiteFooter = _resolveComponent("SiteFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageLoader, {
      isLoading: !_ctx.isRouterReady
    }, null, 8, ["isLoading"]),
    (!_ctx.hideChrome)
      ? (_openBlock(), _createBlock(_component_SiteNav, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, { class: "app-content" }),
    (!_ctx.hideChrome)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.isMounted)
            ? (_openBlock(), _createBlock(_component_SiteFooter, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}